import styled from 'foundations-theming/utils';
/* hs-eslint ignored failing-rules */
/* eslint-disable @typescript-eslint/no-floating-promises */

import PropTypes from 'prop-types';
import memoizeLast from 'transmute/memoizeLast';
import compose from 'transmute/compose';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { View } from 'foundations-components/transitional/components/View';
// @ts-expect-error module not typed
import RecordPropType from 'conversations-prop-types/prop-types/RecordPropType';
import emptyFunction from 'react-utils/emptyFunction';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
// @ts-expect-error module not typed
import CalleeErrorBoundary from './callee-error/CalleeErrorBoundary';
import CRMEmbeddedMessage from './crm-embedded/components/CRMEmbeddedMessage';
import NoCalleesPrompt from './callee-numbers/components/NoCalleesPrompt';
import CallSettingsNumbersActivityCreator from './callee-numbers/components/CallSettingsNumbersActivityCreator';
// @ts-expect-error module not typed
import EnsureCallingAccess from './calling-appeals/components/EnsureCallingAccess';
import { getData, isSucceeded } from 'calling-lifecycle-internal/async-flux-utils/operators/getApiProperties';
import { getCallableObjects, getPhoneNumberProperties, getHasAssociatedObjects, getCallablePhoneNumberProperties } from 'calling-lifecycle-internal/callees/operators/calleesOperators';
import { getCallableObjectAndAssociations } from 'calling-lifecycle-internal/callee-omnibus/operators/calleeOmnibusResultGetters';
import CallingOnboarding from './callee-numbers/components/CallingOnboarding';
// @ts-expect-error module not typed
import withCalleeOmnibus from './callee-omnibus/hoc/withCalleeOmnibus';
import withCallingAccess from './calling-appeals/hoc/withCallingAccess';
import withWidgetState from './widget-state/hoc/withWidgetState';
// @ts-expect-error module not typed
import withAccessLevelPrefetch from './access-level/hoc/withAccessLevelPrefetch';
import { getIsCRMEmbedded } from './utils/getIsCRMEmbedded';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const Wrapper = styled.div.withConfig({
  displayName: "CallNumbersOnboardedWindowPopover__Wrapper",
  componentId: "sc-1mjc01h-0"
})(["max-width:615px;"]);
const CallNumbersOnboardedWindowPopover = props => {
  const hasCallableRecords = memoizeLast(calleesData => {
    const hasAssociatedObjects = getHasAssociatedObjects(calleesData);
    if (hasAssociatedObjects) {
      return true;
    }
    const callableObjects = getCallableObjects(calleesData);
    return callableObjects && callableObjects.some(callableObject => {
      const phoneNumberProperties = getPhoneNumberProperties(callableObject);
      return getCallablePhoneNumberProperties(phoneNumberProperties).size > 0;
    });
  });
  const renderCRMEmbeddedMessage = () => {
    const {
      subjectId,
      objectTypeId
    } = props;
    return /*#__PURE__*/_jsx(CRMEmbeddedMessage, {
      subjectId: subjectId,
      objectTypeId: objectTypeId
    });
  };
  const renderNoCalleesMessage = () => {
    const {
      objectTypeId,
      subjectId
    } = props;
    return /*#__PURE__*/_jsx(NoCalleesPrompt, {
      subjectId: Number(subjectId),
      objectTypeId: objectTypeId,
      shouldShowAddNumber: false
    });
  };
  const renderCallees = () => {
    const {
      appIdentifier,
      onCallButtonClick = emptyFunction,
      objectTypeId,
      asyncCalleeOmnibus,
      asyncSettingsOmnibus,
      widgetState,
      selectedCallProvider,
      selectedFromNumber,
      scopes,
      limits,
      prospectingQueueItemId,
      isUngatedForRedesign,
      gates,
      onLegacyOutboundCallStart
    } = props;
    const calleeOmnibusData = getData(asyncCalleeOmnibus);
    const calleesData = calleeOmnibusData && getCallableObjectAndAssociations(calleeOmnibusData);
    const hasRecords = hasCallableRecords(calleesData);
    return /*#__PURE__*/_jsx(_Fragment, {
      children: !isSucceeded(asyncCalleeOmnibus) || hasRecords ? /*#__PURE__*/_jsx(View, {
        "data-selenium-test": "call-settings-numbers-options",
        children: /*#__PURE__*/_jsx(CallSettingsNumbersActivityCreator, {
          appIdentifier: appIdentifier,
          asyncCalleeOmnibus: asyncCalleeOmnibus,
          asyncSettingsOmnibus: asyncSettingsOmnibus,
          defaultFromNumber: selectedFromNumber,
          limits: limits,
          objectTypeId: objectTypeId,
          onCallButtonClick: onCallButtonClick,
          onLegacyOutboundCallStart: onLegacyOutboundCallStart,
          scopes: scopes,
          selectedCallProvider: selectedCallProvider,
          widgetState: widgetState,
          prospectingQueueItemId: prospectingQueueItemId,
          isUngatedForRedesign: isUngatedForRedesign,
          gates: gates
        })
      }) : renderNoCalleesMessage()
    });
  };
  const {
    appIdentifier,
    scopes,
    limits,
    asyncSettingsOmnibus,
    callingAccess,
    gates,
    onCallButtonClick
  } = props;
  return /*#__PURE__*/_jsx(Wrapper, {
    children: /*#__PURE__*/_jsx(CalleeErrorBoundary, {
      appName: "CALLING",
      children: /*#__PURE__*/_jsx(EnsureCallingAccess, {
        appIdentifier: appIdentifier,
        useFullWidth: false,
        scopes: scopes,
        callingAccess: callingAccess,
        children: /*#__PURE__*/_jsx(CallingOnboarding, {
          asyncSettingsOmnibus: asyncSettingsOmnibus,
          onRegisterFromPhoneNumber: onCallButtonClick,
          onShowOnboardingIntro: onCallButtonClick,
          onClosePopover: onCallButtonClick,
          scopes: scopes,
          limits: limits,
          gates: gates,
          appIdentifier: appIdentifier,
          ignoreNonHSCalling: true,
          children: /*#__PURE__*/_jsx(TFlex, {
            direction: "column",
            children: getIsCRMEmbedded() ? renderCRMEmbeddedMessage() : renderCallees()
          })
        })
      })
    })
  });
};
CallNumbersOnboardedWindowPopover.proptypes = {
  appIdentifier: PropTypes.string.isRequired,
  asyncCalleeOmnibus: RecordPropType('AsyncCalleeOmnibusResult').isRequired,
  asyncSettingsOmnibus: RecordPropType('AsyncSettingsOmnibusResult').isRequired,
  callingAccess: RecordPropType('CallingAccess').isRequired,
  limits: ImmutablePropTypes.map.isRequired,
  objectTypeId: PropTypes.string.isRequired,
  onCallButtonClick: PropTypes.func,
  onLegacyOutboundCallStart: PropTypes.func,
  scopes: ImmutablePropTypes.map.isRequired,
  selectedCallProvider: RecordPropType('CallingProvider'),
  selectedFromNumber: RecordPropType('FromNumber'),
  subjectId: PropTypes.string.isRequired,
  widgetState: ImmutablePropTypes.map.isRequired,
  prospectingQueueItemId: PropTypes.number
};
export default compose(withCalleeOmnibus, withCallingAccess, withWidgetState, withAccessLevelPrefetch)(CallNumbersOnboardedWindowPopover);